import React from 'react';
import { Users } from 'lucide-react';

const PRAYER_ACCENT = { shacharit: '#1e3a5f', mincha: '#92400e', maariv: '#312e81' };

const formatCountdown = (secs) => {
  if (secs < 0) return 'עכשיו';
  if (secs < 60) return `עוד ${secs} שנ׳`;
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  if (m < 60) return `עוד ${m}:${String(s).padStart(2, '0')}`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  return rm === 0 ? `עוד ${h} שע׳` : `עוד ${h}ש׳ ${rm}ד׳`;
};

const StatusBox = ({ msg, isError }) => (
  <div style={{
    width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    direction: 'rtl', fontSize: '1rem', color: isError ? '#c0392b' : '#94a3b8',
  }}>
    {msg}
  </div>
);

const Card = ({ nextMinyan, secondsLeft, upcomingPrayers, allPrayerTimes, title, showTitle, bgColor, loading, error }) => {
  if (loading) return <StatusBox msg="טוען..." />;
  if (error)   return <StatusBox msg={error} isError />;
  if (!nextMinyan) return <StatusBox msg="אין מנינים שנותרו להיום" />;

  const accent = nextMinyan.color || PRAYER_ACCENT[nextMinyan.prayer] || '#0369a1';
  const countdown = formatCountdown(secondsLeft);
  const nextAfter = upcomingPrayers[1] ?? null;
  const bg = bgColor || 'transparent';

  return (
    <div style={{
      width: '100%', height: '100%', display: 'flex', flexDirection: 'column',
      direction: 'rtl', fontFamily: 'inherit', boxSizing: 'border-box',
      backgroundColor: bg,
    }}>
      {showTitle && (
        <div style={{
          padding: '0.65rem 1rem', flexShrink: 0,
          borderBottom: '1px solid #e2e8f0',
          display: 'flex', alignItems: 'center', gap: '0.5rem',
        }}>
          <Users size={15} color="#64748b" />
          <span style={{ fontWeight: 700, fontSize: '0.9rem', color: '#1e293b' }}>{title}</span>
        </div>
      )}

      {/* Main content */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '1.25rem 1rem', gap: '0.25rem',
      }}>
        {/* Color indicator strip */}
        <div style={{
          width: 32, height: 4, borderRadius: 2,
          backgroundColor: accent, marginBottom: '0.5rem',
        }} />

        {/* Prayer name */}
        <div style={{
          fontSize: '2rem', fontWeight: 800,
          color: accent, letterSpacing: '-0.01em',
        }}>
          {nextMinyan.label}
        </div>

        {/* Time */}
        <div style={{
          fontSize: '3.75rem', fontWeight: 900, lineHeight: 1,
          color: '#0f172a', fontVariantNumeric: 'tabular-nums',
          direction: 'ltr', letterSpacing: '-0.05em',
        }}>
          {nextMinyan.time}
        </div>

        {/* Countdown pill */}
        <div style={{
          marginTop: '0.75rem',
          backgroundColor: accent + '15',
          border: `1.5px solid ${accent}35`,
          borderRadius: 100,
          padding: '0.3rem 1.25rem',
          fontSize: '0.95rem', fontWeight: 700, color: accent,
        }}>
          {countdown}
        </div>
      </div>

      {/* Footer: next prayer */}
      {nextAfter && (
        <div style={{
          padding: '0.5rem 1rem', flexShrink: 0,
          borderTop: `1px solid ${accent}20`,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          backgroundColor: accent + '10',
        }}>
          <span style={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 600 }}>
            הבא: {nextAfter.label}
          </span>
          <span style={{
            fontSize: '0.75rem', color: '#64748b', fontWeight: 700,
            fontVariantNumeric: 'tabular-nums', direction: 'ltr',
          }}>
            {nextAfter.time}
          </span>
        </div>
      )}
    </div>
  );
};

export default Card;
